// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumbs_breadcrumbs___fgxM","breadcrumbs__item":"breadcrumbs_breadcrumbs__item__KT4xV","animateStar":"breadcrumbs_animateStar__trnCv"};